import { createFileRoute } from '@tanstack/react-router';
import { getCatalog } from '~/entities/catalog/api';
import { HomePage } from '~/pages/home';

export const Route = createFileRoute('/')({
  loader: async () => getCatalog(),
  component: HomePage,
});
